import styled from "@emotion/styled";
import { FormControl, OutlinedInput, Select } from "@mui/material";

interface StyledFormControlProps {
	width?: number;
}

export const StyledFormControl = styled(FormControl)<StyledFormControlProps>`
	width: ${({ width }) => (width ? `${width}px` : "100%")};
`;

interface StyledSelectProps {
	height?: number;
}

export const StyledSelect = styled(Select)<StyledSelectProps>`
	font-size: 14px;

	& .MuiSelect-select {
		line-height: ${({ height }) => height}px;
		padding-top: 0;
		padding-bottom: 0;
	}

	& .MuiOutlinedInput-notchedOutline {
		border: 1px solid #e0e0e0;
	}
`;

export const SelectInput = styled(OutlinedInput)``;

export const SelectPlaceholder = styled.p`
	font-size: 18px;
	color: #676767;
	opacity: 0.8;
`;

interface SelectContentWrapper {
	height?: number;
}

export const SelectContentWrapper = styled.div<SelectContentWrapper>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: ${({ height }) => height}px;
	padding: 0 20px 0 6px;
`;

export const SelectContentInfoWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
`;

export const SelectContentInfoTitle = styled.span`
	font-size: 22px;
	font-weight: bold;
	line-height: 28px;
`;

export const SelectContentInfoSubtitle = styled.span`
	font-size: 14px;
	line-height: 28px;
`;

export const SelectContentPriceWrapper = styled.div`
	display: flex;
	align-items: flex-end;
`;

export const SelectContentPriceText = styled.span`
	font-size: 32px;
	font-weight: bold;
	line-height: 24px;
`;

export const SelectContentPriceDate = styled.span`
	font-size: 14px;
	line-height: 16px;
	margin-left: 6px;
`;

export const SelectItemWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
`;

export const SelectItemTitle = styled.p`
	color: #858585;
	font-size: 14px;
	padding: 14px 0 16px 16px;
	font-weight: bold;
`;

export const SelectItemInfoWrapper = styled.div`
	display: flex;
	flex-direction: column;
`;

export const SelectItemInfoTitle = styled.span`
	font-size: 16px;
	font-weight: bold;
`;

export const SelectItemInfoSubtiitle = styled.span`
	font-size: 12px;
	color: #5e5e5e;
`;

export const SelectItemPriceWrapper = styled.div`
	display: flex;
	align-items: center;
`;

export const SelectItemPriceText = styled.span`
	font-size: 16px;
	font-weight: bold;
`;

export const SelectItemPriceDate = styled.span`
	font-size: 14px;
	margin-left: 4px;
	color: #5e5e5e;
`;
